import React, { useEffect, useRef, useState } from "react";
import {
  ChatActionType,
  City,
  HotelNights,
  Itinerary,
  TripDay,
} from "../../types";
import { Card, Button, Modal, Form, Collapse } from "react-bootstrap";
import IconComponent from "../IconComponent";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  FaArrowRight,
  FaBus,
  FaCarSide,
  FaHotel,
  FaPlane,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaShip,
  FaTrain,
  FaAngleDown,
  FaAngleUp,
  FaCalendarDays,
  FaLocationDot,
} from "react-icons/fa6";
import MapItinerary from "../MapItinerary";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { routes } from "../../routes/routes";
import { getImages, updateItinerary } from "../../functions/Query";
import { formatDate, addDaysToDate, formatDateToISO } from "../../functions/Utils";
import TransportSearchPanel from "../Transports/TransportSearchPanel";
import HotelSearchPanel from "../Hotels/HotelSearchPanel";
import ActivitySearchPanel from "../ActivitySearchPanel";
import CarRentalSearchPanel from "../CarRentals/CarRentalSearchPanel";
import PhotoBannerGallery from "../PhotoBannerGallery";
import ChatActions from "../ChatActions";
import ChatItinerary from "../ChatItinerary";
import ItineraryTripDays from "./ItineraryTripDays";
import LayoutWrapper from "../../layouts/LayoutWrapper";
import ChatHeader from "../ChatHeader";

const ItineraryCard = ({ itinerary }: { itinerary: Itinerary }) => {
  const [selectedDay, setSelectedDay] = useState<TripDay | undefined>(
    undefined
  );
  const [showModal, setShowModal] = useState(false);
  const [departureDate, setDepartureDate] = useState<Date | null>(null);
  const [departureCity, setDepartureCity] = useState("");
  const [showDrawer, setShowDrawer] = useState(false);
  const [searchType, setSearchType] = useState<string | null>(null);
  const [cities, setCities] = useState<Record<number, City> | []>([]);
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname.startsWith("/itinerary")
    ? "itinerary"
    : "chat";
  const [openStepId, setOpenStepId] = useState<number | null>(null);

  const handleConfirm = async () => {
    // Ici tu peux appeler une API, router vers une page, etc.

    const date_iso_string = departureDate ? formatDateToISO(departureDate) : "";
    setShowModal(false);
    const changes: string[] = [];
    if (pathname == "chat") {
      navigate(
        `${routes.itinerary.path}/${itinerary.uuid}?from=${departureCity}&date=${date_iso_string}`
      );
    } else if (pathname == "itinerary") {
      if (
        date_iso_string !== "" &&
        date_iso_string != itinerary.data.departure_date
      ) {
        itinerary.data.departure_date = date_iso_string;
        changes.push("departure_date");
      }

      if (changes.length && itinerary.uuid) {
        await updateItinerary(itinerary.uuid, { data: itinerary.data });
      }
    }
  };

  const handleselectedAction = (value: string) => {
    if (value === ChatActionType.ITINERARY) return false;

    const conversationId = itinerary?.message?.conversation?.uuid;

    if (conversationId) {
      navigate(
        `${routes.chat.path}/${conversationId}${
          value === ChatActionType.SEARCH ? "?action=search" : ""
        }`
      );
    }

    return false;
  };

  const onImageError = async (itin: Itinerary) => {
    await getImages(itin.data);
    if (itin.uuid) {
      await updateItinerary(itin.uuid, { data: itin.data });
    }
  };

  const searchPanel = (searchType: string) => {
    setSearchType(searchType);
    setShowDrawer(true);
  };

  const getMappedCities = () => {
    if (!itinerary?.data?.cities) return {};

    const mappedCities: Record<number, City> = {};
    itinerary.data.cities.forEach((city: City) => {
      mappedCities[city.id] = city;
    });
    return mappedCities;
  };

  useEffect(() => {
    setCities(getMappedCities());
  }, [itinerary]);

  return (
    <>
      {pathname == "chat" && itinerary && (
        <div className="my-4">
        <ChatItinerary
          itinerary={itinerary}
          onImageError={onImageError}
          selectedDay={selectedDay}
          setShowModal={setShowModal}
          trip_days={
            <ItineraryTripDays
              itinerary={itinerary}
              setSelectedDay={setSelectedDay}
              pathname={pathname}
              setOpenStepId={setOpenStepId}
              openStepId={openStepId}
            />
          }
        />
        </div>

      )}

      {pathname == "itinerary" && (
        <LayoutWrapper
          header={
            <>
              {itinerary?.message?.conversation && (
                <ChatHeader conversation={itinerary.message.conversation} />
              )}
            </>
          }
          left={
            <>
              {itinerary?.message?.conversation && (
                <ChatActions
                  conversation={itinerary.message.conversation}
                  action={ChatActionType.ITINERARY}
                  itinerary={itinerary}
                  handleselectedAction={handleselectedAction}
                />
              )}

              <div className="card border-0 bg-light px-3">
                <div className="card-body py-3">
                  <h2 className="fw-bold m-0">
                    {itinerary.data && itinerary.data.title
                      ? itinerary.data.title
                      : "Itinéraire généré"}
                  </h2>
                  <div className="d-flex">
                    {cities &&
                      itinerary.data.hotel_cities?.slice(0, 10).map(
                        (hotel: HotelNights, index: number) =>
                          hotel.location in cities && (
                            <div
                              className="d-flex align-items-center me-2 text-primary small"
                              key={index}
                            >
                              <FaLocationDot />
                              {cities[hotel.location].cityname}
                            </div>
                          )
                      )}
                  </div>

                  {itinerary.data.departure_date && (
                    <button
                      className="btn btn-outline-info btn-sm d-flex align-items-center pointer mt-2"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <FaCalendarDays size={18} className="me-1" />
                      <span>
                        {formatDate(itinerary.data.departure_date)}
                        <FaArrowRight size={18} className="mx-2" />
                        {formatDate(
                          addDaysToDate(
                            itinerary.data.departure_date,
                            itinerary.data.trip_days.length - 1
                          )
                        )}
                      </span>
                    </button>
                  )}
                </div>

                {itinerary.data.images.length && (
                  <div className="card-body py-3">
                    <PhotoBannerGallery images={itinerary.data.images} />
                  </div>
                )}

                {itinerary && (
                  <div className="card-body">
                    <div className="d-flex gap-2">
                      {itinerary.data.transports && (
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => searchPanel("transports")}
                        >
                          Transports
                        </button>
                      )}
                      {itinerary.data.rental_car && (
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => searchPanel("rental_car")}
                        >
                          Car Rental
                        </button>
                      )}
                      {itinerary.data.hotel_cities && (
                        <button
                          className="btn btn-outline-primary"
                          onClick={() => searchPanel("hotels")}
                        >
                          Hotels & Accommodations
                        </button>
                      )}
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => searchPanel("activities")}
                      >
                        Activities
                      </button>
                    </div>
                  </div>
                )}

                <ItineraryTripDays
                  itinerary={itinerary}
                  setSelectedDay={setSelectedDay}
                  pathname={pathname}
                  setOpenStepId={setOpenStepId}
                  openStepId={openStepId}
                />
              </div>
            </>
          }
          right={
            <>
              <div>
                {itinerary && itinerary.data && (
                  <div className="w-100">
                    <MapItinerary
                      tripDays={itinerary.data.trip_days}
                      selectedDay={selectedDay}
                      height={"calc(100vh - var(--header-height))"}
                    />
                  </div>
                )}
                {!itinerary && (
                  <div
                    className="login-cover h-100 w-100"
                    style={{
                      backgroundImage: "url('/images/lisboa.jpg')",
                      maxHeight: "100vh",
                    }}
                  />
                )}
              </div>
            </>
          }
        />
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Compléter votre recherche</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Date de départ</Form.Label>
              <DatePicker
                selected={departureDate}
                onChange={(date: Date | null) => setDepartureDate(date)}
                dateFormat="yyyy-MM-dd"
                className="form-control"
                minDate={new Date()}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Ville de départ</Form.Label>
              <Form.Control
                type="text"
                value={departureCity}
                onChange={(e) => setDepartureCity(e.target.value)}
                placeholder="ex: Paris"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Annuler
          </Button>
          <Button
            variant="success"
            onClick={handleConfirm}
            // disabled={!departureDate || !departureCity}
          >
            Confirmer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Offcanvas Drawer */}
      {showDrawer && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={() => setShowDrawer(false)}
        ></div>
      )}

      <div
        className={`offcanvas offcanvas-bottom h-75 ${
          showDrawer ? "show" : ""
        }`}
        tabIndex={-1}
        style={{ visibility: showDrawer ? "visible" : "hidden" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title">{searchType}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setShowDrawer(false)}
          />
        </div>
        <div className="offcanvas-body overflow-hidden">
          {searchType == "transports" && (
            <TransportSearchPanel
              key={`flight-${itinerary.uuid}-${itinerary.data.departure_date}`}
              itinerary={itinerary}
              cities={cities}
            />
          )}
          {searchType == "hotels" && (
            <HotelSearchPanel
              key={`hotels-${itinerary.uuid}-${itinerary.data.departure_date}`}
              itinerary={itinerary}
              cities={cities}
            />
          )}
          {searchType == "rental_car" && (
            <CarRentalSearchPanel
              key={`car-${itinerary.uuid}-${itinerary.data.departure_date}`}
              itinerary={itinerary}
              cities={cities}
            />
          )}
          {searchType == "activities" && (
            <ActivitySearchPanel
              key={`activities-${itinerary.uuid}-${itinerary.data.departure_date}`}
              itinerary={itinerary}
              cities={cities}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ItineraryCard;
